import React, { useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer/Footer";
import styles from "./AgencyOnboard.module.css";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useUtil } from "../../../contexts/UtilContext";
import {
  isValidEmail,
  verifyAndFetchUserRoles,
} from "../../../util/utilFunctions";
import { useNavigate } from "react-router-dom";

import { styled } from "@mui/material/styles";
import { toast } from "react-toastify";

// Styled components for centering modal elements
const CenteredDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    textAlign: "center",
  },
}));

const CenteredDialogTitle = styled(DialogTitle)({
  textAlign: "center",
});

const CenteredDialogContent = styled(DialogContent)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const CenteredDialogActions = styled(DialogActions)({
  justifyContent: "center",
  padding: "16px",
});

function AgencyOnboard() {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useUtil();
  const [email, setEmail] = useState("");
  const [missingLicenseModal, setMissingLicenseModal] = useState(false);

  const handleEmailCheck = async () => {
    // console.log("check: ", email);

    if (!email) {
      toast.error("Please provide the Email");
      return;
    }

    // email checker
    if (!isValidEmail(email)) {
      toast.error("Please provide a valid Email format");
      return;
    }

    try {
      showLoader();

      var response = await verifyAndFetchUserRoles(email);
      // console.log("user role checl res: ", response);

      if (
        response.status === 200 &&
        response.data &&
        "success" in response.data
      ) {
        if (response.data.existingUser) {
          // existing user
          if (response.data.isProfessional) {
            // is already a pro
            if (response.data.isBroker) {
              // is already broker
              // should be able to add an agency
              // @TODO: redirect to add agency dash page
              // console.log("broker");
              navigate(`/MyFirstLand/agency/add`);
            } else {
              // is a pro but not a licensed broker
              // show the message
              // @TODO: provide a way to add broker license
              // console.log("only poro");
              setMissingLicenseModal(true);
            }
          } else {
            // registed user but not pro
            // @TODO: redirect to broker onboard with prefilled email
            // console.log("only registered user");
            navigate(`/broker-onbaord?email=${email}`);
          }
        } else {
          // new user
          // proceed to create a new broker account
          // @TODO: redirect to broker onboard with prefilled email
          // console.log("new user");
          navigate(`/broker-onbaord?email=${email}`);
        }
      } else {
        toast.error(
          "Some error occurred while checking the email status. Please try again!"
        );
      }
    } catch (error) {
      toast.error(
        "Some error occurred while fetching email status. Please try again later"
      );

      console.error("Error while checking the email status: ", error);
    } finally {
      hideLoader();
    }
  };

  const handleAddLicense = () => {
    navigate(`/MyFirstLand?category=prolicenses&isAgencyOnboard=true`);
  };

  return (
    <div className={styles.wrapper}>
      <Navbar />
      <div className={styles.container}>
        <div>
          <div className={styles.warningContainer}>
            <div className={styles.icon}>⚠️</div> {/* Optional warning icon */}
            <div className={styles.msg}>
              You need to be a licensed broker to register your agency!
            </div>
          </div>

          <div>
            Please enter your registered email if you already have one. Or, you
            can also enter a new email to start your registration process
          </div>
          <div className={styles.formContainer}>
            <div className={`${styles.formComponent}`}>
              <TextField
                id="email"
                name="email"
                label="Email"
                variant="outlined"
                required
                type="email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className={styles.formComponent}>
              <div className={styles.formAction}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleEmailCheck}
                >
                  Proceed
                </Button>
              </div>
            </div>
          </div>
        </div>
        <CenteredDialog
          open={missingLicenseModal}
          onClose={() => setMissingLicenseModal(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <CenteredDialogTitle id="alert-dialog-title">
            Missing Broker License
          </CenteredDialogTitle>
          <CenteredDialogContent>
            <DialogContentText id="alert-dialog-description">
              An agent account is already registered with the email address, but
              a broker license is required inorder to register an agency!
            </DialogContentText>
            {/* <DialogContentText>
              <strong>{emailDetails.email}</strong>
            </DialogContentText> */}
            <DialogContentText>
              Would you like to add a broker license to this account?
            </DialogContentText>
          </CenteredDialogContent>
          <CenteredDialogActions>
            <Button
              onClick={() => setMissingLicenseModal(false)}
              variant="outlined"
              sx={{ marginRight: 2 }}
            >
              No
            </Button>
            <Button onClick={handleAddLicense} variant="contained" autoFocus>
              Yes
            </Button>
          </CenteredDialogActions>
        </CenteredDialog>
      </div>
      <Footer />
    </div>
  );
}

export default AgencyOnboard;
